import Description from '@mui/icons-material/Description';
import { Link } from '@mui/material';
import { useTranslate } from 'react-admin';

import {
  CampaignSampleExportBody,
  VacationDaysAllocationsSampleExportBody,
} from '@Common/types/bo/b2b/campaigns';

import { useResourceBasePath } from '@sh4res/bo-common/hooks';
import { useServerExport } from '@sh4res/bo-common/hooks/useServerExport';

/** A sample file of the campaign wizard, which the backend prefills with the company's employees */
export const DownloadOperationsFileSample = ({
  label,
  body,
}: {
  label: string;
  body: CampaignSampleExportBody | VacationDaysAllocationsSampleExportBody;
}) => {
  const translate = useTranslate();
  const resourceBasePath = useResourceBasePath();
  const { exportFile, isExporting } = useServerExport();

  return (
    <Link
      component="button"
      onClick={async (event) => {
        event.preventDefault();
        event.stopPropagation();
        await exportFile(`${resourceBasePath}campaigns`, body);
      }}
      underline="hover"
      sx={{
        display: 'flex',
        gap: 1,
        paddingLeft: '5px',
        paddingBottom: '5px',
        pointerEvents: isExporting ? 'none' : undefined,
        cursor: isExporting ? 'default' : undefined,
      }}
      color={isExporting ? 'textDisabled' : undefined}>
      <Description />
      <span>{translate(label)}</span>
    </Link>
  );
};
